
import { formatNumberWithCommas } from '~/fc/Helpers/NumericHelpers';
export default {
    props: ['label', 'priceInput', 'value', 'priceInputValueInitial'],
    data: () => ({
        priceInputValue: 0,
        thumbSize: 0,
        alignment: 'center'
    }),
    created() {
        if (this.priceInputValueInitial) { this.priceInputValue = this.priceInputValueInitial }
    },
    mounted() {
        this.initiateSlider()
    },
    methods: {
        initiateSlider() {
            this.$refs.slider.setAttribute('min', 0)
            this.$refs.slider.setAttribute('max', Object.keys(this.priceInput).length - 1)
            this.handleSliderValuePosition(this.$refs.slider)
        },
        handleSliderValuePosition(input) {
            this.$emit('input', this.getPricingData(this.priceInput))
            const sliderWidth = input.getBoundingClientRect().width - 20
            const multiplier = input.value / input.max
            const left = sliderWidth * multiplier
            const valueWidth = this.$refs.sliderValue.getBoundingClientRect().width
            this.alignment = left > (sliderWidth - valueWidth) ? 'right' : left < valueWidth ? 'left' : 'center'
            this.$refs.sliderTick.style.left = left + 'px'
        },
        getPricingData(obj, pos) {
            return pos !== undefined
                ? obj[this.priceInputValue][pos]
                : obj[this.priceInputValue]
        },
        getPricingDisplay(obj, pos) {
            const value = this.getPricingData(obj, pos)
            return value ? formatNumberWithCommas(value) : 'N/A'
        }
    }
}
